import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Fonts, mediaQuery } from '@styles/index';

export const TEST_SERIES_TAB = {
  ALL: 'all',
  MY: 'my'
};

const Switcher = styled.div`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  width: fit-content;
  max-width: 100%;
  padding: 4px;
  border-radius: 10px;
  background: rgba(192, 207, 221, 0.3);

  ${mediaQuery.uptoMobile} {
    flex-shrink: 0;
  }
`;

const TabButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  background: ${({ $isActive }) =>
    $isActive ? 'var(--color-i-white)' : 'transparent'};

  &:focus-visible {
    outline: 2px solid var(--color-i-white);
    outline-offset: 2px;
  }
`;

const TabLabel = styled.span`
  display: block;
  overflow: hidden;
  font-size: 16px;
  line-height: 18px;
  font-weight: ${({ $isActive }) =>
    $isActive ? Fonts.SEMIBOLD : Fonts.REGULAR};
  color: ${({ $isActive }) =>
    $isActive ? 'var(--color-i-violet-8)' : 'var(--color-i-white)'};
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TABS = [
  { id: TEST_SERIES_TAB.ALL, label: 'All Tests' },
  { id: TEST_SERIES_TAB.MY, label: 'My Tests' }
];

const TestSeriesTabSwitcher = ({
  activeTab,
  onTabChange,
  showMyTab = true
}) => {
  const visibleTabs = showMyTab
    ? TABS
    : TABS.filter(({ id }) => id !== TEST_SERIES_TAB.MY);

  return (
    <Switcher role="tablist" aria-label="Test series view">
      {visibleTabs.map(({ id, label }) => {
        const isActive = activeTab === id;

        return (
          <TabButton
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            $isActive={isActive}
            onClick={() => onTabChange(id)}
          >
            <TabLabel $isActive={isActive}>{label}</TabLabel>
          </TabButton>
        );
      })}
    </Switcher>
  );
};

export default TestSeriesTabSwitcher;

TestSeriesTabSwitcher.propTypes = {
  activeTab: PropTypes.oneOf([TEST_SERIES_TAB.ALL, TEST_SERIES_TAB.MY])
    .isRequired,
  onTabChange: PropTypes.func.isRequired,
  showMyTab: PropTypes.bool
};

TestSeriesTabSwitcher.defaultProps = {
  showMyTab: true
};
